<bb-input-datepicker-ui
  label="Schedule transfer"
  [(ngModel)]="transferDate"
></bb-input-datepicker-ui>
